var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _vm.componentForDataType,
    _vm._b(
      {
        tag: "component",
        staticClass: "screen-control__row-cell",
        attrs: { "cell-type": _vm.cellType },
      },
      "component",
      _vm.propsMapping,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }